import type { IconProps } from "./icon-types";

/**
 * 체크 표시. Checkbox(선택) / Dropdown(selected option) 등에서 공용.
 * 16×16 그리드로 정규화(기존 Checkbox는 12×12였음).
 */
export const CheckIcon = (props: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
    <path
      d="M3.5 8.5l3 3 6-6"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
